import Hero from '../components/Hero';
import Features from '../components/Features';
import Templates from '../components/Templates';
import Contracts from '../components/Contracts';
import Signup from '../components/Signup';
import updateDocumentTitle from '../utils/updateDocumentTitle';

export default function Home() {

  updateDocumentTitle('Home');

  return (
    <>
      <Hero />
      <Features />
      <Templates />
      <Contracts />
      <Signup />
    </>
  );
}